import type { ReactNode } from "react";
import { MessageSquare, Send } from "lucide-react";

export function ChatPanel({
	sourceCount,
	children,
}: {
	sourceCount?: number;
	children: ReactNode;
}) {
	return (
		<div className="border-cv-bdr flex h-full shrink-0 flex-col border-l">
			<div className="border-cv-bdr flex h-11 shrink-0 items-center gap-2 border-b px-4">
				<div className="bg-cv-accent flex h-5 w-5 items-center justify-center rounded">
					<MessageSquare
						className="h-3 w-3 text-white"
						strokeWidth={1.5}
					/>
				</div>
				<span className="text-cv-fg text-xs font-medium">AI Chat</span>
				{sourceCount != null && (
					<span className="text-cv-accent ml-auto text-[9px] font-medium">
						{sourceCount} sources
					</span>
				)}
			</div>
			<div className="flex flex-1 flex-col gap-3 overflow-hidden p-4">
				{children}
			</div>
			<div className="border-cv-bdr flex gap-2 border-t p-3">
				<input
					className="border-cv-bdr bg-cv-bg-elevated text-cv-fg-sec placeholder:text-cv-fg-muted flex-1 rounded border px-2.5 py-1.5 text-[11px] outline-none"
					placeholder="Ask anything about your library..."
					readOnly
				/>
				<button className="bg-cv-accent flex h-7 w-7 shrink-0 items-center justify-center rounded">
					<Send className="h-3 w-3 text-white" strokeWidth={2} />
				</button>
			</div>
		</div>
	);
}
